import React from "react";

import { Strings,ChangeLanguage} from "INTL/i18n";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import changeLanguage from "MODULES/App/actions/ChangeLanguage";
import PaymentRedirect from "./PaymentRedirect";
import { PayerParam } from "./PayerConstants";
import {PageView, initGA} from "MODULES/Tracking";
import { GOOGLE_ANALYTICS } from "CONSTANTS/AppConstants";

import "./Payer.less";
import PaymentBase from "./PaymentBase";
import "./Payer.css";

class PaymentError extends PaymentBase {
  constructor(props) {
    super(props);
    this.state = {
      redirectUrl: "",
    };
  }
  componentDidMount() {
    initGA(GOOGLE_ANALYTICS.TRACKING_ID);
    PageView();
    let searchQueryString = window.location.hash.split("?")[1];
    let redirectQueryString = "?" + window.location.hash.split("?")[2];
    let urlParams = new URLSearchParams(searchQueryString);
    let languageCode = urlParams.get(PayerParam.lang);
    ChangeLanguage(languageCode);
    this.props.changeLanguageInState(languageCode);
    let redirectUrl;
    if (urlParams.get(PayerParam.redirect)) {
      redirectUrl = urlParams.get(PayerParam.redirect) + redirectQueryString;
    }
    this.setState({
      redirectUrl: redirectUrl,
    });
  }

  render() {
    return (
      <div>
        {this.renderHeader(this.props.selectedLanguage)}
        {this.renderErrorPage(Strings("error_msg"))}
        {this.state.redirectUrl && (
          <p>
            <div className="hyperlink">
              <span onClick={this.handleClick}>
                {Strings("clickHereText")}
                {Strings("clickHere")}
              </span>
            </div>
          </p>
        )}
        {this.state.redirectUrl && (
          <PaymentRedirect redirectUrl={this.state.redirectUrl} />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedLanguage: state.LanguageReducer.selectedLanguage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeLanguageInState: changeLanguage,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentError);



// WEBPACK FOOTER //
// ./src/modules/Payer/PaymentError.js